import ThiSensorApi from "@/api/thi-sensor-api";

export default {
  tempData(thiSensorId, fromDate, toDate) {
    return ThiSensorApi.chart(thiSensorId, "temp", fromDate, toDate);
  },
  humidityData(thiSensorId, fromDate, toDate) {
    return ThiSensorApi.chart(thiSensorId, "hum", fromDate, toDate);
  },
  thiData(thiSensorId, fromDate, toDate) {
    return ThiSensorApi.chart(thiSensorId, "thi", fromDate, toDate);
  }
};



// WEBPACK FOOTER //
// ./src/services/ThiSensorService.js